import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import useOrderStore from '../../stores/orderStore'
import useToastStore from '../../stores/toastStore'
import { formatPrice } from '../../utils/format'

const BuyModal = (props) => {
    const { item, show, onHide } = props
    const { addToast } = useToastStore()
    const { createOrder, clearState, loading, error } = useOrderStore()
    const [formData, setFormData] = useState({
        offerLink: '',
    })

    useEffect(() => {
        if (!show) {
            clearState()
            setFormData({ offerLink: '' })
        }
    }, [show, clearState])

    if (!item) {
        return <></>
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }))
    }

    const handleCreateOrder = async () => {
        const orderData = {
            link_offer_steam: formData.offerLink,
            order_items_attributes: [
                {
                    item_id: item.id,
                    price: item.price,
                },
            ],
        }

        const result = await createOrder({ order: orderData })

        if (result.success) {
            addToast('Order thành công!', 'success')
            clearState()
            onHide()
        } else {
            addToast(result.message, 'danger')
        }
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton></Modal.Header>

            <div className="modal-body space-y-20 pd-40">
                <h3>Mua vật phẩm</h3>
                <p className="text-center">
                    <span className="price color-popup">{item.name}</span>
                </p>
                <div className="hr"></div>
                <div className="d-flex justify-content-between">
                    <p className="text-center price color-popup">{item.phase || ''}</p>
                    <p className="text-right price color-popup">{item.float_num || ''}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p> Giá:</p>
                    <p className="text-right price color-popup">{formatPrice(item.price)} vnđ</p>
                </div>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Link offer"
                    name="offerLink"
                    value={formData.offerLink}
                    onChange={handleInputChange}
                    required
                />
                <button className="btn btn-primary" onClick={handleCreateOrder} disabled={loading}>
                    {loading ? 'Loading...' : 'Mua'}
                </button>
                {error && <p className="text-danger mt-2">{error}</p>}
            </div>
        </Modal>
    )
}

export default BuyModal
